<!-- eslint-disable vue/no-mutating-props -->
<template>
  <Dialog v-model:visible="visible" style="width:50%;">
    <template #header>&nbsp;</template>
    <div>
      <h3>{{ _t('label_Colour') }}</h3>
      <span v-for="(bgColor, i) in iconColors" :key="bgColor" class="p-col-3 p-text-center">
        <label :for="`bgColor${i}`">
          <span :style="`background-color: ${bgColor}; border: 1px solid gray`" class="color_sample p-mb-2"/>
          <RadioButton :id="`bgColor${i}`"
                       v-model="button.bgColor"
                       :disabled="!isEditable"
                       :value="bgColor"
                       name="bgColor"
          />
        </label>
      </span>
    </div>
    <h3>{{ _t('label_Icon') }}</h3>
    <Card v-for="(section, s) in icons" :key="section.label">
      <template #title>
        <p>{{ section.label }}</p>
      </template>
      <template #content>
        <div class="p-grid">
          <div v-for="(icon, i) in section.icons" :key="icon" class="p-col-3 p-text-center">
            <label :for="`icon_${s}_${i}`">
              <i :class="`icon p-mb-2 ${icon}`"/>
            </label>
            <br>
            <RadioButton :id="`icon_${s}_${i}`"
                         v-model="button.icon.name"
                         :disabled="!isEditable"
                         :value="icon"
                         name="icon"
            />
          </div>
        </div>
      </template>
    </Card>
  </Dialog>
</template>

<script>
/* eslint-disable vue/no-mutating-props */
export default {
  name: 'IconPickerDialog',
  props: {
    modelValue: { type: Boolean, required: true },
    button: { type: Object, default: null },
    iconColors: { type: Array, required: true },
    icons: { type: Array, required: true },
    isEditable: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  computed: {
    visible: {
      get() { return this.modelValue },
      set(v) { this.$emit('update:modelValue', v) },
    },
  },
}
</script>

<style scoped>
.color_sample {
  display: inline-block;
  width: 48px;
  height: 48px;
  border-radius: 4px;
  margin: 0 auto;
}

.icon {
  font-size: 24px;
}
</style>
